/*
 * @fileOverView Webinar form component definition
 *
 * Exists so webinar-specific analytics events can be tracked.
 */

import Vue from 'vue';
import 'jquery-validation';
import Form from 'components/foundation/forms/form/form.mixin';
import Analytics from 'mixins/analytics.mixin';

/**
 * [Webinar Form Vue]
 * @type {class}
 */
Vue.component('form-webinar-vue', {
  mixins: [
    Analytics,
    Form
  ],

  props: {
    'isModalExpanded': false,
    'webinarId': null
  },

  data: function() {
    return {
      'connectionIndex': null,
      'saveInfo': false,
      'enableSaveInfo': false,
      'enableLink': false
    }
  },

  watch: {
    isModalExpanded: function (newValue, oldValue) {
      if (!oldValue && newValue) {
        this.pushWebinarRegistrationStartedEvent(this.webinarId);
        this.pushFormViewedEvent();
        this.$nextTick(() => {
          this.attachFormStartedEvent(this.$refs.form, this.pushFormStartedEvent);
        });
      }
      else {
        this.$nextTick(() => {
          this.detachFormStartedEvent(this.$refs.form, this.pushFormStartedEvent);
        });
      }
    }
  },

  mounted() {
    // Phone number must appear valid.
    $.validator.addMethod('phone_number', function (value) {
      var phoneNumber = value;

      if (/^$|^([\+]?[0-9]( |-)?)?(\(?[0-9]{3}\)?|[0-9]{3})( |-)?([0-9]{3}( |-)?[0-9]{4}|[0-9]{7})$/.test(phoneNumber)) {
        return true;
      }

      return false;
    }, 'Please enter a valid phone number.');

    // Password must contain at least one uppercase letter, one number, one special character, and be at least 8 characters long.
    $.validator.addMethod('password', function (value) {
      var password = value;

      if (/^(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9]).{8,}$/.test(password)) {
        return true;
      }

      return false;
    }, 'Password must contain at least one uppercase letter, one number, one special character, and be at least 8 characters long.');
  },

  methods: {
    /**
     * Tracks the condition index so other fields can be shown/hidden per value.
     *
     * @method dropdownChanged
     * @param {Number} selectedIndex - The index of the selected dropdown option.
     * @public
     */
    dropdownChanged(selectedIndex) {
      this.connectionIndex = selectedIndex;
    },

    // Method to handle checkbox click
    handleCheckboxClick(event) {
      this.saveInfo = event.target.checked;
    },

    initAnalytics() {
      const pageName = window.mjffPageData ? window.mjffPageData.pageName : '';

      this.setFormAnalyticsData({
        "formType": "Webinar Registration",
        "formName": `webinar registration: ${pageName}`
      });
    },

    validatorHighlight(element, errorClass, validClass) {
      $(element).parent().addClass('field_error');
    },

    validatorUnhighlight(element, errorClass, validClass) {
      $(element).parent().removeClass('field_error');
    },

    checkEmail() {
      const email = $(this.$refs.form).find('input[type="email"]').val();
      const formData = new URLSearchParams();
      formData.append('email', email);

      fetch('/check-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: formData.toString()
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === 'exists') {
          this.enableSaveInfo = false;
          this.enableLink = true;
          this.saveInfo = false;
          $(this.$refs.form).find('input[name="save_info"]').prop("checked", false);
          $(this.$refs.form).find('input[type="password"]').val('');
        } else {
          this.enableSaveInfo = true;
          this.enableLink = false;
        }
      })
      .catch(error => console.error('Error:', error));
    },

    submit(form) {
      // Populate hidden form fields
      this.populateHiddenFormFields(this.$refs.form);

      // Send form data via AJAX
      if ($(this.$refs.form).attr('action') !== '/samllogin') {
        let formData = [];
        if ($(this.$refs.form).attr('action') === '/webinar/guest/submit/handler') {
          // Gather form data
          let formon24GuestData = localStorage.getItem('formon24-guest-data');
          if (formon24GuestData) {
            formon24GuestData = JSON.parse(formon24GuestData);
            formData = $(this.$refs.form).serializeArray().reduce((obj, item) => {
              obj[item.name] = item.value;
              return obj;
            }, {});
            // Merge formon24GuestData with formData
            formon24GuestData.forEach(item => {
              if (!formData.hasOwnProperty(item.name)) {
                formData[item.name] = item.value;
              }
            });
            localStorage.removeItem('formon24-guest-data');
            // Add the "ajaxRequest" key with value true.
            formData['ajaxRequest'] = true;
          } else {
            formData = $(this.$refs.form).serialize();
          }
        } else {
          // Gather form data
          formData = $(this.$refs.form).serialize();
        }

        $.ajax({
          type: 'POST',
          url: $(this.$refs.form).attr('action'), // Assuming the form has an action attribute
          data: formData,
          success: (response) => {
            if (response.status === "success") {
              // Handle success (e.g., show a success message)
              this.pushWebinarRegistrationCompletedEvent(this.webinarId);
              this.pushFormSubmissionSucceededEvent();
              if (response.registered_webinar) {
                this.$refs.form.reset();
                if (!response.upcoming_webinar && response.rediect_url !== null) {
                  window.location.href = response.rediect_url;
                } else {
                  // To handle the case where the user is already registered  (upcoming webinar) for the webinar to show the success message
                  $(this.$refs.form).find('.webinar-submit__label-icon').show();
                  $(this.$refs.form).find('.webinar-submit__label').text(response.message);
                  setTimeout(() => {
                    $(this.$refs.form).find('.webinar-submit__label-icon').hide();
                    $(this.$refs.form).find('.webinar-submit__label').text('');
                  }, 5000); // Clears the text after 5 seconds
                }
              } else if (response.guest_user) {
                if (response.show_popup) {
                  localStorage.setItem('pop-up-data', JSON.stringify(response));
                  window.location.reload();
                } else {
                  window.location.href = response.rediect_url;
                }
              } else {
                  window.location.href = response.rediect_url;
              }
            } else {
              // Handle error (e.g., show an error message)
              $(this.$refs.form).find('.webinar-submit__label-icon').show();
              $(this.$refs.form).find('.webinar-submit__label').text(response.message);
              setTimeout(() => {
                $(this.$refs.form).find('.webinar-submit__label-icon').hide();
                $(this.$refs.form).find('.webinar-submit__label').text('');
              }, 5000); // Clears the text after 5 seconds
            }
          },
          error: (xhr, status, error) => {
            console.error('Form submission failed:', error);
            // Handle error (e.g., show an error message)
            if (xhr.status === 403) {
              window.location.reload();
            }
          }
        });
      } else {
        // Gather form data
        let formData = $(this.$refs.form).serializeArray();
        var jsonData = JSON.stringify(formData);
        localStorage.setItem('formon24-form-data', jsonData);
        window.location.href = '/samllogin';
      }
    }
  }
});
